import { IUserProfile } from '../../pages/UsersPage/constants'
import { uploadInputZones } from '../UploadDropzone/types'

export interface IEventContent {
  description: string
  files: {
    extension: string
    id: number
    is_deleted: boolean
    is_pinned: string
    link: string
    name: string
    size: number
    uploaded_at: string
    uuid: string
  }[]
  id: number
  link: string
  report: number
  title: string
  type: uploadInputZones
  uuid: string
  questions: any[]
}

export interface ITimelineEvent {
  created_at: string
  id: number
  report: number
  title: string
  type: eventTypes
  person: IUserProfile
  uuid: string
  content?: IEventContent
  description: string
  files?: IEventContent
}

export enum eventTypes {
  MATERIAL_ADDED = 'MATERIAL_ADDED',
  FILE_EDIT = 'FILE_EDIT',
  FILE_UPLOAD = 'FILE_UPLOAD',
  EDIT = 'EDIT',
}
